export const safeClearInterval = (intervalProcess: NodeJS.Timeout) => {
  if (intervalProcess) clearInterval(intervalProcess)
}
